module.exports = [
  {
    path: '/more_api/*',
    target: 'https://moreapi.informing.cn/v1',
    pathRewrite: {
      '^/more_api': ''
    }
  },
  {
    path: '/api/*',
    // target: 'http://jw.yachedu.com/api',
    // target: 'http://lz.cn/api',
    // target: 'http://113.240.230.4:81/api',
    target: 'http://10.89.60.175:8080/api',
    pathRewrite: {
      '^/api': ''
    }
  },
  {
    path: '/uploads/*',
    // target: 'http://jw.yachedu.com/api',
    // target: 'http://lz.cn/api',
    // target: 'http://113.240.230.4:81/api',
    target: 'http://10.89.60.175:8080/uploads',
    pathRewrite: {
      '^/uploads': ''
    }
  },
  {
    path: '/MeetingRoom/*',
    target: 'http://todo-api.informing.cn',
    pathRewrite: {
      '^/MeetingRoom': ''
    }
  },
  {
    path: '/Todo/*',
    target: 'http://todo-api.informing.cn',
    pathRewrite: {
      '^/Todo': ''
    }
  },
  {
    path: '/Itinerary/*',
    target: 'http://todo-api-dev.informing.cn',
    pathRewrite: {
      '^/Itinerary': ''
    }
  },
  {
    path: '/Notice/*',
    target: 'http://todo-api.informing.cn',
    pathRewrite: {
      '^/Notice': ''
    }
  },
  {
    path: '/Feedback/*',
    target: 'http://todo-api-dev.informing.cn',
    pathRewrite: {
      '^/Feedback': ''
    }
  },
  {
    path: '/ZhiHuiSmsNotice/*',
    target: 'http://todo-api-dev.informing.cn',
    pathRewrite: {
      '^/ZhiHuiSmsNotice': ''
    }
  },
  {
    path: '/HonestReport/*',
    target: 'http://report.informing.cn',
    pathRewrite: {
      '^/HonestReport': ''
    }
  },
  // {
  //   path: '/HonestReport/*',
  //   target: 'http://r.cn',
  //   pathRewrite: {
  //     '^/HonestReport': ''
  //   }
  // }
  {
    path: '/LeaveRequest/*',
    target: 'http://todo-api.informing.cn',
    pathRewrite: {
      '^/LeaveRequest': ''
    }
  },
  {
    path: '/moreapi/*',
    target: 'http://ningxiang-apps.informing.cn/'
    // pathRewrite: {
    //   '^/more_api': ''
    // }
  }
]



// WEBPACK FOOTER //
// ./src/dev-variable/proxys.js